var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReactionOn = function SvgReactionOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.027 5.54a5.1 5.1 0 0 0-1.111-1.618 5.183 5.183 0 0 0-3.64-1.48A5.2 5.2 0 0 0 10 3.595a5.216 5.216 0 0 0-3.275-1.154 5.18 5.18 0 0 0-3.641 1.48 5.05 5.05 0 0 0-1.521 3.607c0 .65.132 1.328.396 2.018.22.576.537 1.174.941 1.777.641.955 1.522 1.951 2.616 2.961a29 29 0 0 0 3.683 2.877l.463.297c.205.13.469.13.674 0l.463-.297a29.6 29.6 0 0 0 3.683-2.877c1.094-1.01 1.975-2.006 2.616-2.96a9 9 0 0 0 .941-1.778c.264-.69.396-1.367.396-2.018a5 5 0 0 0-.408-1.99"
  })));
};
export default SvgReactionOn;